export default __webpack_public_path__ + "static/media/i02.3853aae6.gif";